(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.OtherPracticesController = (function(superClass) {
    extend(OtherPracticesController, superClass);

    function OtherPracticesController(scope, transitions, modalInstance, http, selections, survey) {
      var ref, ref1, ref10, ref11, ref12, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.http = http;
      this.selections = selections;
      this.survey = survey;
      this.save = bind(this.save, this);
      OtherPracticesController.__super__.constructor.apply(this, arguments);
      this.scope.save = this.save;
      this.scope.selections = this.selections;
      this.scope.survey = {
        id: (ref = this.survey) != null ? ref.id : void 0,
        questions: [
          {
            text: "Do you practice Integrated Pest Management when selecting and applying chemical products on your farm?",
            answer: (ref1 = this.survey) != null ? ref1.question1 : void 0
          }, {
            text: "When handling waste from your farm (containers, pallets, not crop residue), do you look for opportunities to reuse and recycle (e.g. composting, alternative markets, etc.)?",
            answer: (ref2 = this.survey) != null ? ref2.question2 : void 0
          }, {
            text: "Do you perform regular maintenance and, if necessary, calibration of your equipment and machinery?",
            answer: (ref3 = this.survey) != null ? ref3.question3 : void 0
          }, {
            text: "If farming is your only source of income, do you have financial safeguards in place to minimize risk to crop losses, such as crop insurance?",
            answer: (ref4 = this.survey) != null ? ref4.question4 : void 0
          }
        ],
        managed_irrigated_acres: (ref5 = (ref6 = this.survey) != null ? ref6.managed_irrigated_acres : void 0) != null ? ref5 : 0,
        managed_dryland_acres: (ref7 = (ref8 = this.survey) != null ? ref8.managed_dryland_acres : void 0) != null ? ref7 : 0,
        autocalculate_managed_irrigated_acres: (ref9 = (ref10 = this.survey) != null ? ref10.autocalculate_managed_irrigated_acres : void 0) != null ? ref9 : true,
        autocalculate_managed_dryland_acres: (ref11 = (ref12 = this.survey) != null ? ref12.autocalculate_managed_dryland_acres : void 0) != null ? ref11 : true
      };
    }

    OtherPracticesController.prototype.save = function(pretending) {
      return this.http.post('backend/grower/other-practices/save', {
        year: this.selections.year,
        crop: this.selections.crop,
        id: this.scope.survey.id,
        questions: this.scope.survey.questions,
        managed_irrigated_acres: this.scope.survey.managed_irrigated_acres,
        managed_dryland_acres: this.scope.survey.managed_dryland_acres,
        autocalculate_managed_irrigated_acres: this.scope.survey.autocalculate_managed_irrigated_acres,
        autocalculate_managed_dryland_acres: this.scope.survey.autocalculate_managed_dryland_acres
      }).then((function(_this) {
        return function(response) {
          if (!pretending) {
            return _this.closeWithAlert({
              type: 'success',
              msg: 'Successfully saved Other Practices'
            });
          }
        };
      })(this));
    };

    return OtherPracticesController;

  })(DialogController);

}).call(this);
